module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-network-tab2.5df9c8a2.png";